export const addWithCondition = <T>(item: T, condition: boolean): T[] =>
  condition ? [item] : [];
